export const PROCESSING = 'PROCESSING';
export const DONE = 'DONE';
export const ERROR = 'ERROR';

export const CHANGE_LANG = 'CHANGE_LANG';
export const LOCAL_STORAGE_LANG_KEY = 'kcell_smsgw_lang';

export const GET_CUSTOMERS_PROCESSING = 'GET_CUSTOMERS_PROCESSING';
export const GET_CUSTOMERS_SUCCESS = 'GET_CUSTOMERS_SUCCESS';
export const GET_CUSTOMERS_FAILURE = 'GET_CUSTOMERS_FAILURE';

export const CHANGE_CUSTOMER = 'CHANGE_CUSTOMER';
export const OFFER_APPROVEMENT_CHANGED = 'OFFER_APPROVEMENT_CHANGED';

export const UPDATE_TOKEN = 'UPDATE_TOKEN';

export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';

export const OPEN_MODAL = 'OPEN_MODAL';
export const CLOSE_MODAL = 'CLOSE_MODAL';

export const ADD_MSISDNS = 'ADD_MSISDNS';
export const ADD_MSISDNS_FROM_CONTACTS = 'ADD_MSISDNS_FROM_CONTACTS';
export const ADD_MSISDNS_FROM_GROUPS = 'ADD_MSISDNS_FROM_GROUPS';
export const ADD_MSISDNS_FROM_FILE = 'ADD_MSISDNS_FROM_FILE';
export const SHOW_MSISDNS = 'SHOW_MSISDNS';
export const PREVIEW_CAMPAIGN = 'PREVIEW_CAMPAIGN';

export const SET_CONTACTS_COUNT = 'SET_CONTACTS_COUNT';
export const LOCAL_STORAGE_CLIENT_BIN = 'kcell_cabinet_client_bin';

export const CREATE_AND_SEND = 'CREATE_AND_SEND';
export const CREATE_DRAFT = 'CREATE_DRAFT';
export const UPDATE_DRAFT = 'UPDATE_DRAFT';
export const SEND_CAMPAIGN = 'SEND_CAMPAIGN';

export const MAX_DAYS_BEFORE_SMS_CAMPIGN = 10;
export const DATE_FORMAT = 'YYYY-MM-DD';

// **************************
// RESOURCE NAMES
export const CAMPAIGNS_RESOURCE_NAME = 'Campaigns';
export const CONTACTS_RESOURCE_NAME = 'Contacts';
export const CONTACTS_GROUPS_RESOURCE_NAME = 'ContactsGroups';
export const SENDERS_RESOURCE_NAME = 'Senders';
export const DETAILS_RESOURCE_NAME = 'Details';
